import api from "../../../helpers/api";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const API_ERROR = "LOGIN_API_ERROR";
export const SOCIAL_LOGIN = "SOCIAL_LOGIN";

// Mirrors the permission-extraction logic in Hooks/usePermission.js so we can
// resolve the post-login landing route before any component mounts.
const extractPermissionSet = (user) => {
  const set = new Set();
  if (!user) return set;
  if (Array.isArray(user.permissions)) {
    user.permissions.forEach((p) => set.add(typeof p === 'string' ? p : p?.name));
    return set;
  }
  if (Array.isArray(user.roles)) {
    user.roles.forEach((role) => {
      (role?.permissions || []).forEach((p) => set.add(typeof p === 'string' ? p : p?.name));
    });
  }
  return set;
};

const resolveLandingRoute = (user) => {
  const perms = extractPermissionSet(user);
  if (perms.has('report:view')) return '/reporting';
  if (perms.has('service-request:read')) return '/service-requests';
  return '/settings/my-account';
};

export const loginUser = (user, navigate) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_USER }); // Set loading state

    // API CALL HAPPENS HERE
    const response = await api.post("/api/auth/login", user);
    const { data } = response;

    // Store user profile data WITHOUT token (token is in HttpOnly cookie)
    const { token, ...userData } = data;
    localStorage.setItem("authUser", JSON.stringify(userData));

    dispatch(loginSuccess(data.user));
    navigate(resolveLandingRoute(data.user));
  } catch (error) {
    dispatch(apiError(error.response?.data?.message || "Login failed"));
  }
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,  // This will now store the user data in the Redux store
  };
};

export const logoutUser = (history) => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  };
};